export default function(pixels, perMeter) {
  return Math.ceil((pixels / perMeter) * 100)
}



// WEBPACK FOOTER //
// ./src/utils/perPixelCalc.js